import { axios } from '@/utils/request'

// 获取库存列表
export function getStockList(params) {
  return axios({
    url: `/stocks`,
    method: 'get',
    params
  })
}

//获取商品在途订单总表
export function getWayallstock(params) {
  return axios({
    url: `/purchase/transit`,
    method: 'get',
    params
  })
}

//到货正常/异常
export function updateAllstock(params) {
  return axios({
    url: `/purchase/transit/save`,
    method: 'post',
    data: params
  })
}

//获取上架商品详情表
export function getWaystock(purchase_id, params) {
  return axios({
    url: `/putaway/${purchase_id}`,
    method: 'get',
    params
  })
}

//收获商品提交
export function addWaystock(params) {
  return axios({
    url: `/purchase/transit/goods/putaway`,
    method: 'post',
    data: params
  })
}

//获取盘点库存
export function getInventory(params) {
  return axios({
    url: `/takestock`,
    method: 'get',
    params
  })
}

//盘点库存提交
export function Inventory(params) {
  return axios({
    url: `/stock/check`,
    method: 'post',
    data: params
  })
}
//获取复盘库存
export function getReviewInventory(params) {
  return axios({
    url: `/checkstock`,
    method: 'get',
    params
  })
}

//复盘库存提交
export function reviewInventory(params) {
  return axios({
    url: `/checkstock`,
    method: 'post',
    data: params
  })
}

//获取机器抄码表（初始版）
export function getCopyTable(params) {
  return axios({
    url: `/copy`,
    method: 'get',
    params
  })
}

//提交机器抄码表
export function subCopyTable(params) {
  return axios({
    url: `/copy`,
    method: 'post',
    data: params
  })
}

//获取机器抄码表(完整版)
export function getCopyTables(params) {
  return axios({
    url: `/meters`,
    method: 'get',
    params
  })
}

//修改机器抄码表
export function subCopyTables(meter_id, params) {
  return axios({
    url: `/meters/${meter_id}`,
    method: 'put',
    data: params
  })
}

//获取运营报表
export function getAnalyTable(params) {
  return axios({
    url: `/turnover`,
    method: 'get',
    params
  })
}

//提交营业额
export function postVolume(params) {
  return axios({
    url: `/turnover`,
    method: 'post',
    data: params
  })
}

//获取库存
export function getStockData(params) {
  return axios({
    url: `/stocks`,
    method: 'get',
    params
  })
}

//清除盘点数据
export function clearData() {
  return axios({
    url: `/clear_data`,
    method: 'put',
  })
}
// 以下为新加-------------------
// 导出门店库存
export function exportStock(params) {
  return axios({
    url: '/stocks/export',
    method: 'get',
    params: params
  })
}
// 获取库存变动详情
export function getStockdetail(id, params) {
  return axios({
    url: `/stocks/${id}`,
    method: 'get',
    params
  })
}
// 调拨记录查询
export function getAllocationRecord(params) {
  return axios({
    url: `/stock/move/record`,
    method: 'get',
    params
  })
}

// 导出门店库存变更记录
export function exportStockDetail(params) {
  return axios({
    url: '/stocks/export_detail',
    method: 'get',
    params: params
  })
}
// 在途总表-操作日志
export function getWayDetail(params) {
  return axios({
    url: `/purchase/${params.id}/record`,
    method: 'get',
    params
  })
}
// 在途订单详情
export function getWaystockDetail(params) {
  return axios({
    url: `/purchase/transit/${params.id}/detail`,
    method: 'get',
    params: params
  })
}

//库存异动记录
export function getStockRecord(params) {
  return axios({
    url: `/stock/${params.id}/record`,
    method: 'get',
    params: params
  })
}
//库存调拨
export function moveStock(params) {
  return axios({
    url: `/stock/move`,
    method: 'post',
    data: params
  })
}
// 获取备注列表
export function getRemarkList(params, id) {
  return axios({
    url: `/purchase/${id}/remarks`,
    method: 'get',
    params: params
  })
}
//查询订单是否正常
export function getPurchaseIsNormal(id) {
  return axios({
    url: `/purchase/transit/${id}/is_normal`,
    method: 'get',
  })
}

//处理完毕
export function purchaseComplete(id) {
  return axios({
    url: `/purchase/${id}/complete`,
    method: 'post',
  })
}

// 新盘点列表
export function getStocksCheckList(params) {
  return axios({
    url: `/stocks/check`,
    method: 'get',
    params
  })
}

//新库存异动表
export function getStockRecordAbnormals(params) {
  return axios({
    url: `/stock/record/abnormals`,
    method: 'get',
    params
  })
}

//新库存异动审阅
export function reviewStockRecordAbnormal(params) {
  return axios({
    url: "/stock/record/abnormal/review",
    method: 'post',
    data: params
  })
}

//同意/拒绝库存异动
export function confirmStockRecordAbnormal(params) {
  return axios({
    url: "/stock/record/abnormal/confirm",
    method: 'post',
    data: params
  })
}

//测试结存单
export function testInventoryList(){
  return axios({
    url:"/stocks/inventory_list/test"
  })
}

//结存单明细
export function GetInventoryList(params){
  return axios({
    url:"/stocks/inventory_list",
    params
  })
}

//汇总结存单
export function GetInventoryListCollect(params){
  return axios({
    url:"/stocks/inventory_list/collect",
    params
  })
}